module.exports = __webpack_public_path__ + "static/media/teatro@2x.db6b8a11.png";